<template>
  <div class="sip-modal">
      <div v-for="(item, i) of data" :key="item.title" >
        <div class="sip-modal-item" :data-id="i">

          <small>{{i}}</small>
          <div class="sip_modal_title" v-html="item.title" />

          <div class="sip_modal_body_w" >
            
            <div v-html="item.text" class="sip_modal_body" />
            <div v-if="!$isMob">
              <div v-if="item.img" v-for="(img, i) of item.img" :key="img">
                <img :src="`${$server}${img}`" class="sip_modal_img" :data-img="i" />
              </div>
            </div>
            <div v-if="$isMob">
              <div v-if="item.img" v-for="(img, i) of item.imgMob" :key="img">
                <img :src="`${$server}${img}`" class="sip_modal_img" :data-img="i" />
              </div>
            </div>
            
          </div>

        </div>
      </div>
  </div>
</template>


<script>
import { data } from '../data.js'

export default {
  name: 'Modal',
  data() {
    return {
      data
    }
  },
}
</script>

<style lang="stylus" scope>
.sip-modal
  background #052430
  display flex
  flex-direction column
  align-items: center
.sip-modal-item
  max-width 700px
  background #FFF
  padding 20px 0
  margin-bottom 20px
  position relative
  small
    position absolute
    top 10px
    right 10px

  .sip_modal_img
    margin-top 20px
    @media screen and (max-width: 900px)
      margin-top 10px
      width 100%
  .sip_modal_title
    font-weight 900
    font-size 48px
    line-height 56px
    text-transform uppercase
    color #006EB9
    margin-bottom 10px
    padding 0 30px
    @media screen and (max-width: 900px)
      font-size 30px
      line-height 34px
  .sip_modal_title2
    font-style normal
    font-weight bold
    font-size 24px
    line-height 130%
    color #006EB9
    margin-bottom 15px
  .sip_divide_text
    width 100%
    text-align center
    position relative
    margin-top 15px
    margin-bottom 15px
    &:after
      content ''
      position: absolute
      top 10px
      left 0
      width 100%
      height 1px
      border-bottom: 1px solid rgba(78, 114, 125, 0.85);
      box-shadow: 0px 1px 0px #FFFFFF;
      z-index 1
    span
      background-color #FFF
      position relative
      padding 0 10px
      font-weight bold
      font-size 19px
      line-height 130%
      text-align center
      color #006EB9
      z-index 2

  .sip_modal_body_w
    overflow-y auto
    overflow-x hidden
    max-height 420px
    margin-right 5px
    padding-bottom 40px
    &::-webkit-scrollbar
      width 0.5em
    &::-webkit-scrollbar-track
      background-color #eee
    &::-webkit-scrollbar-thumb
      background-color #CCC
      border-radius 10px
    @media screen and (min-width 900px) and (max-height: 700px)
      overflow-y: auto
      margin-right 5px
      height 47vh
    @media screen and (max-width: 900px)
      height 65vh
      overflow-y scroll
      margin-right 5px
      // padding-right 20px
    .sip_modal_body
      padding 0 30px
  .sip_modal_fade
    width 100%
    height 1px
    position relative
    &:after
      content ''
      position absolute
      top -47px
      left 0
      width 100%
      height 50px
      background linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)
  .sip_modal_btn_space
    padding 10px 20px
    font-size 14px
    line-height 89.19%
    text-align center
    color #FFFFFF
    text-shadow 0px 1px 0px rgba(0, 0, 0, 0.25)
    background #2F7F98
    border 1px solid #FFFFFF
    box-shadow inset 0px -3px 0px rgba(0, 0, 0, 0.2)
    border-radius 6px
    max-width 140px
    margin 20px auto 0 auto
    cursor pointer
    @media screen and (min-width 900px) and (max-height: 700px)
      margin 10px auto 0 auto
    span
      display block
      width 24px
      height 1px
      margin 8px auto 0 auto
      border: 1px solid #FFFFFF;
      box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.25)
      position relative
      &:before, &:after
        content ''
        position absolute
        top -3px
        width 3px
        height 1px
        border 1px solid #fff
        background #FFF
        transform rotate(90deg)
      &:before
        left -4px
      &:after
        right -4px

.sip-modal-item[data-id="s0"] .sip_modal_img
  margin-left 20px
  @media screen and (max-width: 900px)
    width calc( 100% - 40px )

.sip-modal-item[data-id="s2"] .sip_modal_img[data-img="1"]
  margin-left 20px
  @media screen and (max-width: 900px)
    width calc( 100% - 40px )

</style>
